import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { bcPaymentsService } from '../../services';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import { formatGold } from '../../utils/goldNotation';

const STATUS_LABELS = { PENDING: 'Pendente', PAID: 'Pago', DONATED: 'Doado' };
const ROLE_LABELS = { ATAQUE: 'Ataque', BUFF: 'Buff', SUPORTE: 'Suporte' };

const BcPaymentLookupPage = () => {
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [results, setResults] = useState([]);
  const [totals, setTotals] = useState(null);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!search.trim()) return;

    try {
      setLoading(true);
      setError('');
      const data = await bcPaymentsService.lookup(search.trim());
      setResults(data.results);
      setTotals(data.totals);
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao buscar pagamentos.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-br from-slate-800/80 to-slate-900/80 backdrop-blur-xl rounded-2xl p-6 border border-white/10 shadow-xl">
        <h1 className="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-orange-400 to-red-400 bg-clip-text text-transparent mb-4">
          🔎 Consulta de Pagamentos BC
        </h1>
        <form onSubmit={handleSearch} className="flex gap-3">
          <Input
            placeholder="Nome do personagem ou piloto"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            variant="dark"
          />
          <Button type="submit" loading={loading}>
            <Search className="w-4 h-4" /> Buscar
          </Button>
        </form>
      </div>

      {error && (
        <div className="bg-red-500/10 border border-red-500/50 rounded-xl p-4">
          <p className="text-red-400">{error}</p>
        </div>
      )}

      {totals && (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="bg-gradient-to-br from-slate-800/80 to-slate-900/80 backdrop-blur-xl rounded-2xl p-6 border border-white/10 shadow-xl">
            <p className="text-gray-400 text-sm">Recebido</p>
            <p className="text-2xl font-bold text-green-400" title={Number(totals.received).toLocaleString('pt-BR')}>{formatGold(totals.received)}</p>
          </div>
          <div className="bg-gradient-to-br from-slate-800/80 to-slate-900/80 backdrop-blur-xl rounded-2xl p-6 border border-white/10 shadow-xl">
            <p className="text-gray-400 text-sm">Doado</p>
            <p className="text-2xl font-bold text-cyan-400" title={Number(totals.donated).toLocaleString('pt-BR')}>{formatGold(totals.donated)}</p>
          </div>
          <div className="bg-gradient-to-br from-slate-800/80 to-slate-900/80 backdrop-blur-xl rounded-2xl p-6 border border-white/10 shadow-xl">
            <p className="text-gray-400 text-sm">Pendente</p>
            <p className="text-2xl font-bold text-yellow-400" title={Number(totals.pending).toLocaleString('pt-BR')}>{formatGold(totals.pending)}</p>
          </div>
        </div>
      )}

      {results.length > 0 && (
        <div className="bg-gradient-to-br from-slate-800/80 to-slate-900/80 backdrop-blur-xl rounded-2xl p-6 border border-white/10 shadow-xl">
          <div className="space-y-2">
            {results.map((r, index) => (
              <div key={`${r.bcPaymentId}-${index}`} className="flex flex-wrap justify-between items-center gap-2 p-3 rounded-xl bg-white/5 border border-white/10">
                <div>
                  <p className="text-white font-medium">{r.specialEventName}</p>
                  <p className="text-gray-400 text-sm">{r.characterName} • {ROLE_LABELS[r.role]}</p>
                </div>
                <p className="text-white font-bold">{formatGold(r.shareAmount)}</p>
                <span className="text-sm text-gray-300">{STATUS_LABELS[r.status]}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default BcPaymentLookupPage;
